import Vue, { CreateElement, VNode, VueConstructor } from "vue";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "./TransactionView.vue";

interface TransactionModule {
  default: VueConstructor<Vue>;
  typeGuard: (details: any) => boolean;
}

const context = require.context("./", true, /\.\/Transaction[a-zA-Z]*\/index.ts/);
const transactionModules = context.keys().reduce((out, key) => {
  const transactionModule = context(key);
  out.push(transactionModule);
  return out;
}, [] as TransactionModule[]);

export function getTransactionItem(transaction: Transaction): VueConstructor<Vue> {
  const specialTransaction = transactionModules.find(module => module.typeGuard(transaction.details));
  if (specialTransaction) return specialTransaction.default;
  return Vue.extend({
    render: (h: CreateElement): VNode => h(TransactionView, { props: { transaction } }),
  });
}
